import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/pexels-sorry.webp?nf_resize=fit&w=500'
import _imports_1 from '@/assets/images/pexels-painting.webp?nf_resize=fit&w=500'
import _imports_2 from '@/assets/images/pexels-telephone.webp?nf_resize=fit&w=500'


const _hoisted_1 = { class: "flex h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "h-screen grid grid-cols-1 sm:grid-cols-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "justify-self-center sm:justify-self-end self-end sm:self-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "h-48 sm:h-64 w-auto",
    width: "64",
    height: "48"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-600 font-mono" }, " photo by alleksana from Pexels ")
], -1)
const _hoisted_4 = { class: "pt-4 px-8 justify-self-center sm:justify-self-start self-start sm:self-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-5xl font-medium font-primary text-black" }, " It's not you, its us ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "py-2 px-1 text-xl text-primary font-secondary" }, " maybe try again? ", -1)
const _hoisted_7 = {
  key: 1,
  class: "h-screen grid grid-cols-1 sm:grid-cols-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "justify-self-center sm:justify-self-end self-end sm:self-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "h-48 sm:h-64 w-auto",
    width: "64",
    height: "48"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-600 font-mono" }, " photo by Daian Gan from Pexels ")
], -1)
const _hoisted_9 = { class: "pt-4 px-8 justify-self-center sm:justify-self-start self-start sm:self-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-5xl font-medium font-primary text-black" }, " painting a masterpiece ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "py-2 px-1 text-xl text-primary font-secondary" }, " takes time. This page is not yet ready. ", -1)
const _hoisted_12 = {
  key: 2,
  class: "h-screen grid grid-cols-1 sm:grid-cols-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "justify-self-center sm:justify-self-end self-end sm:self-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "h-48 sm:h-64 w-auto",
    width: "64",
    height: "48"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-600 font-mono" }, " Photo by pixabay from Pexels ")
], -1)
const _hoisted_14 = { class: "pt-4 px-8 justify-self-center sm:justify-self-start self-start sm:self-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-5xl font-medium font-primary text-black" }, " Nobody Picked Up ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "py-2 px-1 text-xl text-primary font-secondary" }, " Looks like that page does not exist. ", -1)
const _hoisted_17 = {
  key: 3,
  class: "self-center mx-auto"
}
const _hoisted_18 = { class: "text-3xl font-medium" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-6 mt-4 border-gray-800" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SolidButtonVue = _resolveComponent("SolidButtonVue")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HollowButtonVue = _resolveComponent("HollowButtonVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.statusCode === '500')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }, [
              _createVNode(_component_SolidButtonVue, {
                text: 'Go Back',
                class: "mt-4"
              })
            ])
          ])
        ]))
      : (_ctx.statusCode === '300')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createVNode(_component_SolidButtonVue, {
                    text: 'Go Back Home',
                    class: "mt-4"
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : (_ctx.statusCode === '404')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
                }, [
                  _createVNode(_component_SolidButtonVue, {
                    text: 'Go Back',
                    class: "mt-4"
                  })
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, "Error " + _toDisplayString(_ctx.statusCode), 1),
              _hoisted_19,
              _createVNode(_component_router_link, {
                to: "/",
                class: "w-24 mx-auto"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_HollowButtonVue, { text: 'Go Home' })
                ]),
                _: 1
              })
            ]))
  ]))
}